import React, { useEffect, useState } from "react";
import Step1BasicInfo from "./Step1BasicInfo";
import Step2Inventory from "./Step2Inventory";
import Step4Description from "./Step4Description";
import Step5Media from "./Step5Media";
import FinalSubmit from "./FinalSubmit";
import ProductAPI from "../../../api/inventory/ProductApi";
import { useLocation, useNavigate } from "react-router-dom";

const steps = [
  { label: "Media & Info", icon: "fas fa-info-circle fs-18" },
  { label: "Pricing & Inventory", icon: "ti ti-receipt fs-18" },
  { label: "Description & SEO", icon: "ti ti-world fs-18" },
  { label: "Media & Video", icon: "ti ti-capture fs-18" },
  { label: "Final Submit", icon: "ti ti-check fs-18" },
];

const WizardWrapper = () => {
  let id = "";

  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [slug, setSlug] = useState("");
  const [formData, setFormData] = useState({});
  const [completedSteps, setCompletedSteps] = useState([]);
  const [productId, setProductId] = useState(null || id);
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.id) {
      setProductId(location.state.id);

      setCompletedSteps(Array.from({ length: 5 }, (_, i) => i));
    }
  }, [location.state]);

  useEffect(() => {
    const initialize = async () => {
      try {
        // ✅ Agar edit mode hai to draft mat chalao
        if (location.state?.id) {
          setProductId(location.state.id);
          setCompletedSteps(Array.from({ length: 5 }, (_, i) => i));
          setLoading(false);
          return;
        }

        // ✅ Agar new product hai tab draft chalao
        const res = await ProductAPI.draft();

        if (res.code === 200) {
          const result = res.data;

          setFormData(result);
          sessionStorage.setItem("product", result?.title);
          sessionStorage.setItem("productId", result?.productId);

          setSlug(result.slug);
          setStep(result.wizardStep - 1);
          setProductId(result?.productId);
          setCompletedSteps(
            Array.from({ length: result.wizardStep }, (_, i) => i),
          );
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, [location.state]);

  const nextStep = (data) => {
    let newData = {};

    if (data instanceof FormData) {
      for (const [key, value] of data.entries()) {
        newData[key] = value;
      }
    } else {
      newData = data;
    }

    setFormData((prev) => ({ ...prev, ...newData }));
    setCompletedSteps((prev) => [...prev, step]);
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const goToStep = (index) => {
    if (id || completedSteps.includes(index) || index === step) {
      setStep(index);
    }
  };

  const handleFinalSubmit = (finalData) => {
    navigate("/product");
  };

  if (loading) {
    return <div>Loading product draft...</div>; // ← spinner ya message
  }

  const renderStepContent = () => {
    switch (step) {
      case 0:
        return <Step1BasicInfo productId={productId} nextStep={nextStep} />;
      case 1:
        return (
          <Step2Inventory
            previousformData={formData}
            productId={productId}
            slug={slug}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 2:
        return (
          <Step4Description
            productId={productId}
            slug={slug}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <Step5Media
            nextStep={nextStep}
            productId={productId}
            slug={slug}
            prevStep={prevStep}
          />
        );
      case 4:
        return (
          <FinalSubmit
            prevStep={prevStep}
            productId={productId}
            onSubmit={handleFinalSubmit}
          />
        );
      default:
        return null;
    }
  };

  const progressPercent = (step / steps.length) * 100;

  return (
    <>
      <div className="row mb-3">
        <div className="col-xl-12">
          <div className="settings-wrapper d-flex">
            <div className="settings-sidebar product-sidebar" id="sidebar2">
              <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu5" className="sidebar-menu">
                  <h4 className="fw-bold fs-18 mb-2 pb-2">Product Details</h4>
                  <ul className="store-setting-tabs">
                    {steps.map((stepItem, index) => (
                      <li key={index}>
                        <button
                          className={`nav-link text-start w-100 ${
                            step === index ? "active" : ""
                          }`}
                          onClick={() => goToStep(index)}
                          disabled={
                            id
                              ? false
                              : !completedSteps.includes(index) &&
                                index !== step
                          }
                          style={{
                            cursor:
                              id ||
                              completedSteps.includes(index) ||
                              index === step
                                ? "pointer"
                                : "not-allowed",
                            color:
                              id ||
                              completedSteps.includes(index) ||
                              index === step
                                ? "#000"
                                : "#999",
                          }}
                        >
                          <i className={stepItem.icon}></i>
                          <span className="fs-14 fw-medium ms-2">
                            {stepItem.label}
                          </span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="card flex-fill mb-0 w-50">
              <div className="progress" style={{ height: "6px" }}>
                <div
                  className="progress-bar bg-primary"
                  role="progressbar"
                  style={{ width: `${progressPercent}%` }}
                  aria-valuenow={progressPercent}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              {renderStepContent()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WizardWrapper;
